import { NgModule } from '@angular/core';
// import { PreloadAllModules } from '@angular/router';
import {
  PreloadAllModules,
  RouterModule,
  Routes,
} from '@angular/router';

import { CustomPreloadingStrategy } from './preload/custom-preloading-starategy';
import { AuthGuardGuard } from './guards/auth-guard.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/admin-dashboard',
    // redirectTo: '/',
    pathMatch: 'full'
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
  //   // canActivate:[AuthGuardGuard]
  // },
  {
    path: '',
    loadChildren: () => import('./pages/admin-dashboard/admin-dashboard.module').then( m => m.AdminDashboardPageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
    // canActivate:[AuthGuardGuard]
  },
  {
    path: 'selectoption',
    loadChildren: () => import('./pages/selectoption/selectoption.module').then( m => m.SelectoptionPageModule)
  },
  {
    path: 'category',
    loadChildren: () => import('./pages/category/category.module').then( m => m.CategoryPageModule)
  },
  {
    path: 'categorylist',
    loadChildren: () => import('./pages/categorylist/categorylist.module').then( m => m.CategorylistPageModule)
  },
  {
    path: 'addproduct',
    loadChildren: () => import('./pages/add-product/add-product.module').then( m => m.AddProductPageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'addproduct/:category_id',
    loadChildren: () => import('./pages/add-product/add-product.module').then( m => m.AddProductPageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'productlist',
    loadChildren: () => import('./pages/productlist/productlist.module').then( m => m.ProductlistPageModule)
  },
  {
    path: 'create-category',
    loadChildren: () => import('./pages/create-category/create-category.module').then( m => m.CreateCategoryPageModule)
  },
  {
    path: 'forms',
    loadChildren: () => import('./pages/form-page/form-page.module').then( m => m.FormPagePageModule)
  },
  {
    path: 'categories',
    loadChildren: () => import('./pages/select-category/select-category.module').then( m => m.SelectCategoryPageModule)
  },
  {
    path: 'product-attr-list',
    loadChildren: () => import('./pages/product-attr-list/product-attr-list.module').then( m => m.ProductAttrListPageModule)
  },
  {
    path: 'add-product-attr',
    loadChildren: () => import('./pages/add-product-attr/add-product-attr.module').then( m => m.AddProductAttrPageModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/orders/orders.module').then( m => m.OrdersPageModule),
    canActivate:[AuthGuardGuard]
  },
  // {
  //   path: 'orders/:order_id',
  //   loadChildren: () => import('./pages/orders/orders.module').then( m => m.OrdersPageModule)
  // },
  {
    path: 'order/:id',
    loadChildren: () => import('./pages/order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'add-image',
    loadChildren: () => import('./pages/add-image/add-image.module').then( m => m.AddImagePageModule),
    data : { preload : true }
  },
  {
    path: 'add-option',
    loadChildren: () => import('./pages/add-option/add-option.module').then( m => m.AddOptionPageModule)
  },
  {
    path: 'add-category',
    loadChildren: () => import('./pages/add-category/add-category.module').then( m => m.AddCategoryPageModule)
  },
  {
    path: 'admin-dashboard',
    loadChildren: () => import('./pages/admin-dashboard/admin-dashboard.module').then( m => m.AdminDashboardPageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'customers',
    loadChildren: () => import('./pages/customerlist/customerlist.module').then( m => m.CustomerlistPageModule),
    data: { preload: true }
  },
  {
    path: 'customer-detail',
    loadChildren: () => import('./pages/customer-detail/customer-detail.module').then( m => m.CustomerDetailPageModule)
  },
  {
    path: 'address-list',
    loadChildren: () => import('./pages/address-list/address-list.module').then( m => m.AddressListPageModule)
  },
  {
    path: 'popup-attribute',
    loadChildren: () => import('./pages/popup-attribute/popup-attribute.module').then( m => m.PopupAttributePageModule),
    data: { preload: true }
  },
  {
    path: 'add-address',
    loadChildren: () => import('./pages/add-address/add-address.module').then( m => m.AddAddressPageModule),
    data: { preload: true }
  },
  {
    path: 'add-notes',
    loadChildren: () => import('./pages/add-notes/add-notes.module').then( m => m.AddNotesPageModule)
  },
  {
    path: 'retrieve-order',
    loadChildren: () => import('./pages/retrieve-order/retrieve-order.module').then( m => m.RetrieveOrderPageModule),
    data: {  preload: true }
  },
  {
    path: 'pos-print',
    loadChildren: () => import('./pages/pos-print/pos-print.module').then( m => m.PosPrintPageModule),
    data: {  preload: true }
  },
  {
    path: 'customer-address',
    loadChildren: () => import('./pages/customer-address/customer-address.module').then( m => m.CustomerAddressPageModule),
    data: {  preload: true }
  },
  {
    path: 'customer-wallet',
    loadChildren: () => import('./pages/customer-wallet/customer-wallet.module').then( m => m.CustomerWalletPageModule)
  },
  {
    path: 'customer-orders',
    loadChildren: () => import('./pages/customer-orders/customer-orders.module').then( m => m.CustomerOrdersPageModule)
  },
  {
    path: 'customer-rewards',
    loadChildren: () => import('./pages/customer-rewards/customer-rewards.module').then( m => m.CustomerRewardsPageModule)
  },
  {
    path: 'report',
    loadChildren: () => import('./pages/report/report.module').then( m => m.ReportPageModule),
    canActivate:[AuthGuardGuard],
    data: {  preload: true }
  },
  {
    path: 'scan',
    loadChildren: () => import('./pages/scan/scan.module').then( m => m.ScanPageModule)
  },   
  {
    path: 'edit-order',
    loadChildren: () => import('./pages/edit-order/edit-order.module').then( m => m.EditOrderPageModule),
    data: {  preload: true }
  },
  {
    path: 'yourcart',
    loadChildren: () => import('./pages/yourcart/yourcart.module').then( m => m.YourcartPageModule),
    data: { preload: true }
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/inventory.module').then( m => m.InventoryPageModule)
  },
  {
    path: 'new-customer',
    loadChildren: () => import('./pages/new-customer/new-customer.module').then( m => m.NewCustomerPageModule),
    data: { preload: true }
  },
  {
    path: 'discount',
    loadChildren: () => import('./pages/discount/discount.module').then( m => m.DiscountPageModule)
  },
  {
    path: 'product-stock-history',
    loadChildren: () => import('./pages/product-stock-history/product-stock-history.module').then( m => m.ProductStockHistoryPageModule)
  },
  {
    path: 'shipping-method-list',
    loadChildren: () => import('./pages/shipping-method-list/shipping-method-list.module').then( m => m.ShippingMethodListPageModule),
    data: { preload: true }
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then( m => m.HistoryPageModule),
  },
  {
    path: 'product-settings',
    loadChildren: () => import('./pages/product-settings/product-settings.module').then( m => m.ProductSettingsPageModule)
  },
  {
    path: 'add-discount',
    loadChildren: () => import('./pages/add-discount/add-discount.module').then( m => m.AddDiscountPageModule)
  },
  {
    path: 'add-discount/:discount_id',
    loadChildren: () => import('./pages/add-discount/add-discount.module').then( m => m.AddDiscountPageModule)
  },
  {
    path: 'category-modal',
    loadChildren: () => import('./pages/category-modal/category-modal.module').then( m => m.CategoryModalPageModule),
    data: {  preload: true }
  },
  {
    path: 'product-modal',
    loadChildren: () => import('./pages/product-modal/product-modal.module').then( m => m.ProductModalPageModule),
    data: {  preload: true }
  },
  {
    path: 'payment-method',
    loadChildren: () => import('./pages/payment-method/payment-method.module').then( m => m.PaymentMethodPageModule),
    data: {  preload: true }
  },
  {
    path: 'shipping-method',
    loadChildren: () => import('./pages/shipping-method/shipping-method.module').then( m => m.ShippingMethodPageModule),
    data: {  preload: true }
  },
  {
    path: 'my-accounts',
    loadChildren: () => import('./pages/my-accounts/my-accounts.module').then( m => m.MyAccountsPageModule)
  },
  {
    path: 'rich-text-box',
    loadChildren: () => import('./pages/rich-text-box/rich-text-box.module').then( m => m.RichTextBoxPageModule),
    data: {  preload: true }
  },
  {
    path: 'product-brands',
    loadChildren: () => import('./pages/product-brands/product-brands.module').then( m => m.ProductBrandsPageModule),
    data: {  preload: true }
  },
  {
    path: 'specification-attributes',
    loadChildren: () => import('./pages/specification-attributes/specification-attributes.module').then( m => m.SpecificationAttributesPageModule),
    data: { preload: true }
  },
  {
    path: 'discount-type',
    loadChildren: () => import('./pages/discount-type/discount-type.module').then( m => m.DiscountTypePageModule),
    data : { preload : true }
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'image-gallery',
    loadChildren: () => import('./pages/image-gallery/image-gallery.module').then( m => m.ImageGalleryPageModule),
    data : { preload : true }

  },
  {
    path: 'order-status',
    loadChildren: () => import('./pages/order-status/order-status.module').then( m => m.OrderStatusPageModule),
    data : { preload : true }
  },
  {
    path: 'web-page',
    loadChildren: () => import('./pages/web-page/web-page.module').then( m => m.WebPagePageModule)
  },
  {
    path: 'web-page/:page_route',
    loadChildren: () => import('./pages/web-page/web-page.module').then( m => m.WebPagePageModule)
  },
  {
    path: 'web-page/:page_route/:page_route_1',
    loadChildren: () => import('./pages/web-page/web-page.module').then( m => m.WebPagePageModule)
  },
  {
    path: 'webform-child',
    loadChildren: () => import('./pages/webform-child/webform-child.module').then(m => m.WebformChildPageModule)
  },
  {
    path: 'edit-webformchild',
    loadChildren: () => import('./pages/edit-webformchild/edit-webformchild.module').then(m => m.EditWebformchildPageModule)
  },
  {
    path: 'thankyou',
    loadChildren: () => import('./pages/thankyou/thankyou.module').then( m => m.ThankyouPageModule),
    data: { preload: true }
  },
  {
    path: 'thankyou/:order_id',
    loadChildren: () => import('./pages/thankyou/thankyou.module').then( m => m.ThankyouPageModule),
    data: { preload: true }
  },
  {
    path: 'inventory-management',
    loadChildren: () => import('./pages/inventory-management/inventory-management.module').then( m => m.InventoryManagementPageModule),
    canActivate:[AuthGuardGuard],
    data: { preload: true }
  },
  {
    // path: 'inventory-price-mapping',
    path: 'product-list',
    loadChildren: () => import('./pages/inventory-price-mapping/inventory-price-mapping.module').then( m => m.InventoryPriceMappingPageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'add-issue',
    loadChildren: () => import('./pages/add-issue/add-issue.module').then(m => m.AddIssuePageModule),
    data: { preload: true }

  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportPageModule),
    canActivate:[AuthGuardGuard],
    data: { preload: true }
  },
  {
    path: 'return-policy',
    loadChildren: () => import('./pages/return-policy/return-policy.module').then( m => m.ReturnPolicyPageModule)
  },
  {
    path: 'manage-price',
    loadChildren: () => import('./pages/manage-price/manage-price.module').then( m => m.ManagePricePageModule)
  },
  {
    path: 'manage-price/:product',
    loadChildren: () => import('./pages/manage-price/manage-price.module').then( m => m.ManagePricePageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'profile-info',
    loadChildren: () => import('./pages/profile-info/profile-info.module').then( m => m.ProfileInfoPageModule)
  },

  {
    path: 'my-profile',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'my-profile/order/:order_id',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'my-profile/view-category/:category_id',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'my-profile/view-product/:category_id',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'my-profile/view-product',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'my-profile/:info',
    loadChildren: () => import('./pages/my-profile/my-profile.module').then( m => m.MyProfilePageModule),
    canActivate:[AuthGuardGuard]
  },
  {
    path: 'forgetten',
    loadChildren: () => import('./pages/forgetten/forgetten.module').then( m => m.ForgettenPageModule)
  },
  {
    path: 'replacement-policy',
    loadChildren: () => import('./pages/replacement-policy/replacement-policy.module').then( m => m.ReplacementPolicyPageModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsPageModule)
  },
  {
    path: 'terms/:id',
    loadChildren: () => import('./pages/terms/terms.module').then( m => m.TermsPageModule)
  },
  // {
  //   path: 'inventory',
  //   loadChildren: () => import('./component/inventory/inventory.module').then( m => m.InventoryPageModule)
  // }
  // {
  //   path: 'login',
  //   loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  // }
];

@NgModule({
  imports: [
    // RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, anchorScrolling: 'enabled' })
    RouterModule.forRoot(routes, { 
      // preloadingStrategy: PreloadAllModules 
      preloadingStrategy: CustomPreloadingStrategy
    }),
    // [RouterModule.forChild(routes)]
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {}
